import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { dataLayerPublish } from '@dhl/datalayer'

export const useUpdateLanguageOnChange = (enabled: boolean): void => {
  const { i18n } = useTranslation()
  const callbackFn = useCallback(() => {
    if (enabled) {
      i18n.on('languageChanged', () => {
        try {
          const language = i18n.language.substring(0, 2)
          window.OneTrust.changeLanguage(language)
        } catch (err) {
          dataLayerPublish('ERROR', { id: 'one-trust', error: err, context: 'language-changed' })
        }
      })
    }

    return () => i18n.off('languageChanged')
  }, [i18n, enabled])

  useEffect(() => {
    callbackFn()
  }, [callbackFn])
}
